import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { useTheme } from '@mui/material/styles';
import { Host } from '@proposify/mfe-tools';
import { useUserContext } from 'providers/UserProvider';
import { lazy, Suspense, useMemo } from 'react';

const FolderSelectionModule = lazy(() => import('core-management-remote/folder-selection'));

const Container = ({ children }: { children: React.ReactNode }) => (
  <Box height="100px" overflow="hidden">
    {children}
  </Box>
);

type FolderSelectionProps = {
  assetName: string;
  onFolderSelected: (folderId: string) => void;
  assetType: 'SECTION' | 'SNIPPET';
};

export function FolderSelection({ assetName, assetType, onFolderSelected }: FolderSelectionProps) {
  const { data: user } = useUserContext();
  const theme = useTheme();

  const injectables = useMemo(
    () => ({
      user,
      theme,
      assetName,
      assetType,
      sendEvent: (event: { folderId: string }) => {
        onFolderSelected(event.folderId);
      },
    }),
    [user, theme, assetName, assetType, onFolderSelected]
  );

  if (!user) {
    return <Container>{null}</Container>;
  }

  return (
    <Container>
      <Host name="folder-selection-dialog" injectables={injectables}>
        <Suspense fallback={<Container>{null}</Container>}>
          <Fade in={true} timeout={600}>
            <Box>
              <FolderSelectionModule />
            </Box>
          </Fade>
        </Suspense>
      </Host>
    </Container>
  );
}
